import {
  DeleteButton,
  EditButton,
  List,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { ModalParametrizeTemplates } from "components/modals";
import { IDispatchTemplate } from "interfaces";
import { FC } from "react";

export const ParameterizeTriggersTemplatesList: FC<
  IResourceComponentsProps
> = () => {
  const { tableProps } = useTable({
    resource: "v1/repique-campaign",
    hasPagination: false,
  });

  return (
    <List
      createButtonProps={{
        children: "Incluir",
        type: "primary",
      }}
    >
      <Table
        {...tableProps}
        rowKey="_id"
        pagination={{
          pageSize: 1000,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} registros`,
        }}
      >
        <Table.Column
          dataIndex="name"
          key="name"
          title="Campanha"
          render={(value) => <TextField value={value} />}
        />

        <Table.Column
          dataIndex="templates"
          key="templates"
          title="Quantidade de Templates"
          render={(templates) => (
            <TextField value={templates ? templates.length : 0} />
          )}
        />

        <Table.Column<IDispatchTemplate>
          title="Ações"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <ModalParametrizeTemplates
                campaignId={record._id}
                dataSource={record.templates}
                loading={tableProps.loading}
              />

              <EditButton hideText size="small" recordItemId={record._id} />

              <DeleteButton
                hideText
                size="small"
                recordItemId={record._id}
                confirmTitle="Deseja excluir essa campanha?"
                successNotification={{
                  message: "Campanha excluída com sucesso",
                  type: "success",
                }}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
